import { Link } from "wouter";
import { Button } from "@/components/ui/button";
import { DollarSignIcon, HeartIcon, GlobeIcon } from "lucide-react";

export default function GetInvolved() {
  return (
    <section id="get-involved" className="py-16 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="lg:text-center mb-12">
          <h2 className="text-base text-primary-600 font-semibold tracking-wide uppercase">Get Involved</h2>
          <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-slate-900 sm:text-4xl">
            Join our mission
          </p>
          <p className="mt-4 max-w-2xl text-xl text-slate-600 lg:mx-auto">
            There are many ways to support our work and make a difference in people's lives.
          </p>
        </div>

        <div className="mt-12">
          <div className="grid grid-cols-1 gap-10 sm:grid-cols-3">
            {/* Donate */}
            <div className="bg-white overflow-hidden shadow-lg rounded-xl border border-primary-100">
              <div className="px-6 py-8 text-center">
                <div className="w-20 h-20 rounded-full bg-gradient-to-br from-green-100 to-green-50 mx-auto flex items-center justify-center shadow-sm border border-green-200">
                  <span className="text-4xl">💵</span>
                </div>
                <h3 className="mt-5 text-xl font-semibold text-slate-900">Donate</h3>
                <p className="mt-3 text-slate-600">
                  Your financial support helps us provide critical services and expands our reach to more individuals in need.
                </p>
                <div className="mt-6">
                  <Link href="/get-involved#donate">
                    <Button className="bg-gradient-to-r from-green-600 to-primary-600 hover:from-green-700 hover:to-primary-700">Make a Donation</Button>
                  </Link>
                </div>
              </div>
            </div>

            {/* Volunteer */}
            <div className="bg-white overflow-hidden shadow-lg rounded-xl border border-primary-100">
              <div className="px-6 py-8 text-center">
                <div className="w-20 h-20 rounded-full bg-gradient-to-br from-red-100 to-red-50 mx-auto flex items-center justify-center shadow-sm border border-red-200">
                  <span className="text-4xl text-red-500">❤️</span>
                </div>
                <h3 className="mt-5 text-xl font-semibold text-slate-900">Volunteer</h3>
                <p className="mt-3 text-slate-600">
                  Share your time and expertise as a mentor, job coach, or event coordinator. Your skills can change lives.
                </p>
                <div className="mt-6">
                  <Link href="/get-involved#volunteer">
                    <Button className="bg-gradient-to-r from-red-500 to-primary-600 hover:from-red-600 hover:to-primary-700">Become a Volunteer</Button>
                  </Link>
                </div>
              </div>
            </div>

            {/* Partner */}
            <div className="bg-white overflow-hidden shadow-lg rounded-xl border border-primary-100">
              <div className="px-6 py-8 text-center">
                <div className="w-20 h-20 rounded-full bg-gradient-to-br from-blue-100 to-blue-50 mx-auto flex items-center justify-center shadow-sm border border-blue-200">
                  <span className="text-4xl text-blue-600">🤝</span>
                </div>
                <h3 className="mt-5 text-xl font-semibold text-slate-900">Partner With Us</h3>
                <p className="mt-3 text-slate-600">
                  Businesses, nonprofits, and community organizations can collaborate with us to create more opportunities.
                </p>
                <div className="mt-6">
                  <Link href="/get-involved#partner">
                    <Button className="bg-gradient-to-r from-blue-600 to-primary-600 hover:from-blue-700 hover:to-primary-700">Become a Partner</Button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
